import * as React from "react";
import { Checkbox } from "@/components/ui/checkbox";

export type DaysOfMonthProps = {
  onChange: React.Dispatch<React.SetStateAction<number[]>>;
  days: number[];
};

export type DaysOfMonthType = {
  value: number;
  isCheck: boolean;
};

const emptyDay: number[] = [];

export const DaysOfMonth = ({ onChange, days = emptyDay }: DaysOfMonthProps) => {
  const daysOfMonth = syncDaysOfMonth(days);
  const changeValue = (idx: number) => {
    const newDaysOfMonth = daysOfMonth.reduce((preValue: number[], currentValue, index) => {
      if ((index === idx && !currentValue.isCheck) || (index !== idx && currentValue.isCheck)) {
        return [...preValue, currentValue.value];
      }
      return preValue;
    }, []);
    onChange(newDaysOfMonth);
  };

  return (
    <div className="flex flex-wrap gap-1">
      {daysOfMonth.map((item, idx) => (
        <div className="flex items-center space-x-2 mr-2 w-10" key={`days-of-month-${item.value}-${idx}`}>
          <Checkbox
            checked={item.isCheck}
            onClick={() => changeValue(idx)}
            value={item.value}
            id={`days-of-month-${item.value}-${idx}`}
          />
          <label
            htmlFor={`days-of-month-${item.value}-${idx}`}
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {item.value}
          </label>
        </div>
      ))}
    </div>
  );
};

export const syncDaysOfMonth = (list: number[]): DaysOfMonthType[] => {
  const arrayDay = [];
  for (let i = 1; i <= 31; i++) {
    arrayDay.push({ value: i, isCheck: list.includes(i) });
  }
  return arrayDay;
};
